export default __webpack_public_path__ + "static/media/4.4fd8b861.jpg";